import { useQuery } from '@apollo/client';
import { customersApi } from '../api';
import { APIRequestSort } from 'global';
import { ActivityListFilters, ActivityPageTabs, ActivityType } from 'modules/dealActivity';

interface Params {
  customerAccountId: string;
  sorting: APIRequestSort;
  filters: ActivityListFilters;
  activityType: ActivityPageTabs;
}

export function useActivityHubTabDataFetch(params: Params) {
  const { sorting, filters, customerAccountId, activityType } = params;

  const { data, loading, previousData } = useQuery(customersApi.getCustomerDealActivities, {
    variables: {
      input: {
        sorting,
        filters: {
          ...(filters.search ? { search: filters.search } : {}),
          ...(activityType !== ActivityPageTabs.ALL
            ? { types: [activityType] }
            : { types: Object.values(ActivityType) }),

          ...(activityType === ActivityPageTabs.CALL ? { callFilters: filters.callFilters } : {}),
        },
        customerAccountId,
      },
    },
  });

  const activityList = (data ?? previousData)?.customer?.customerDealActivities?.list ?? [];
  const prevActivityList = previousData?.customer?.customerDealActivities?.list ?? [];

  return {
    loading,
    prevActivityList,
    activityList: activityList ?? prevActivityList,
  };
}
